<template>
	<div>
		<div style="display: flex;align-items: center;">
			<div class="flex-item-center"
				style="align-items: center;margin: 10px;display: flex;margin-top: 10px;font-size: 14px;">
				<div style="font-size: 14px;">是否显示</div>
				<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
					<div @click="dataItem.globalDialog.isOpen = true"
						:style="{backgroundColor: dataItem.globalDialog.isOpen?'#8c62ff':'#fff',color: dataItem.globalDialog.isOpen?'#fff':'#000',border: dataItem.globalDialog.isOpen?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">是</span>
					</div>
					<div @click="dataItem.globalDialog.isOpen = false"
						:style="{backgroundColor:!dataItem.globalDialog.isOpen?'#8c62ff':'#fff',color: !dataItem.globalDialog.isOpen?'#fff':'#000',border: !dataItem.globalDialog.isOpen?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">否</span>
					</div>
				</div>
			</div>

			<div class="flex-item-center"
				style="align-items: center;margin: 10px;display: flex;margin-top: 10px;font-size: 14px;">
				<div style="font-size: 14px;">是否自动关闭</div>
				<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
					<div @click="dataItem.globalDialog.authClose = true"
						:style="{backgroundColor: dataItem.globalDialog.authClose?'#8c62ff':'#fff',color: dataItem.globalDialog.authClose?'#fff':'#000',border: dataItem.globalDialog.authClose?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">是</span>
					</div>
					<div @click="dataItem.globalDialog.authClose = false"
						:style="{backgroundColor:!dataItem.globalDialog.authClose?'#8c62ff':'#fff',color: !dataItem.globalDialog.authClose?'#fff':'#000',border: !dataItem.globalDialog.authClose?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">否</span>
					</div>
				</div>
			</div>
			
			
			
			
			
			
			
			<div class="flex-item-center"
				style="align-items: center;margin: 10px;display: flex;margin-top: 10px;font-size: 14px;">
				<div style="font-size: 14px;">仅首页弹出</div>
				<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
					<div @click="dataItem.globalDialog.onlyHomeShow = 'true'"
						:style="{backgroundColor: dataItem.globalDialog.onlyHomeShow == 'true'?'#8c62ff':'#fff',color: dataItem.globalDialog.onlyHomeShow == 'true'?'#fff':'#000',border: dataItem.globalDialog.onlyHomeShow == 'true'?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">是</span>
					</div>
					<div @click="dataItem.globalDialog.onlyHomeShow = 'false'"
						:style="{backgroundColor:dataItem.globalDialog.onlyHomeShow  == 'false'?'#8c62ff':'#fff',color: dataItem.globalDialog.onlyHomeShow  == 'false'?'#fff':'#000',border: dataItem.globalDialog.onlyHomeShow == 'false'?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">否</span>
					</div>
				</div>
			</div>
			
			
			<div class="flex-item-center"
				style="align-items: center;margin: 10px;display: flex;margin-top: 10px;font-size: 14px;">
				<div style="font-size: 14px;">关闭后不在弹出</div>
				<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
					<div @click="dataItem.globalDialog.closeNoShow = 'true'"
						:style="{backgroundColor: dataItem.globalDialog.closeNoShow == 'true'?'#8c62ff':'#fff',color: dataItem.globalDialog.closeNoShow == 'true'?'#fff':'#000',border: dataItem.globalDialog.closeNoShow == 'true'?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">是</span>
					</div>
					
					<div @click="dataItem.globalDialog.closeNoShow = 'false'"
						:style="{backgroundColor:dataItem.globalDialog.closeNoShow  == 'false'?'#8c62ff':'#fff',color: dataItem.globalDialog.closeNoShow  == 'false'?'#fff':'#000',border: dataItem.globalDialog.closeNoShow == 'false'?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">否</span>
					</div>
				</div>
			</div>
			
		</div>

		<div class="flex-item-center"
			style="align-items: center;margin: 10px;display: flex;margin-top: 10px;font-size: 14px;">
			<div style="font-size: 14px;">pc端长宽</div>
			<el-input size="small" style="width: 160px;margin-left: 10px;" placeholder="请输入内容" v-model="dataItem.globalDialog.width" clearable>
				<template slot="append">px</template>
			</el-input>
			<el-input size="small"  style="width: 160px;margin-left: 10px;" placeholder="请输入内容" v-model="dataItem.globalDialog.height" clearable>
				<template slot="append">px</template>
			</el-input>
		</div>

	<!-- 	<div class="flex-item-center"
			style="align-items: center;margin: 10px;display: flex;margin-top: 10px;font-size: 14px;">
			<div style="font-size: 14px;">弹窗pc端高度</div>
			<el-input size="small"  style="width: 260px;margin-left: 10px;" placeholder="请输入内容" v-model="dataItem.globalDialog.height" clearable>
				<template slot="append">px</template>
			</el-input>
		</div> -->
		<div class="flex-item-center"
			style="align-items: center;margin: 10px;display: flex;margin-top: 10px;font-size: 14px;">
			<div style="font-size: 14px;">移动端长宽</div>
			<el-input size="small"  style="width: 160px;margin-left: 10px;" placeholder="请输入内容" v-model="dataItem.globalDialog.phoneWidth" clearable>
				<template slot="append">px</template>
			</el-input>
			<el-input size="small" style="width: 160px;margin-left: 10px;" placeholder="请输入内容" v-model="dataItem.globalDialog.phoneHeight" clearable>
				<template slot="append">px</template>
			</el-input>
		</div>

		<div class="flex-item-center"
			style="align-items: center;margin: 10px;display: flex;margin-top: 10px;font-size: 14px;">
			<div style="font-size: 14px;">进站几秒显示</div>
			<el-input-number :min="0" style="margin-left: 20px;" size="small"
				v-model="dataItem.globalDialog.comeOpenTime"></el-input-number>
		</div>
		<div class="flex-item-center"
			style="align-items: center;margin: 10px;display: flex;margin-top: 10px;font-size: 14px;">
			<div style="font-size: 14px;">进站几秒自动关闭</div>
			<el-input-number :min="0" style="margin-left: 20px;" size="small"
				v-model="dataItem.globalDialog.authCloseTime"></el-input-number>
		</div>

		<!-- <div class="flex-item-center"
			style="align-items: center;margin: 10px;display: flex;margin-top: 20px;font-size: 14px;">
			<div style="font-size: 14px;">标题位置</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="dataItem.globalDialog.titPosition = 'start'"
					:style="{backgroundColor: dataItem.globalDialog.titPosition == 'start'?'#8c62ff':'#fff',color: dataItem.globalDialog.titPosition == 'start'?'#fff':'#000',border: dataItem.globalDialog.titPosition == 'start'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">靠左</span>
				</div>
				<div @click="dataItem.globalDialog.titPosition = 'center'"
					:style="{backgroundColor:dataItem.globalDialog.titPosition == 'center'?'#8c62ff':'#fff',color: dataItem.globalDialog.titPosition == 'center'?'#fff':'#000',border: dataItem.globalDialog.titPosition == 'center'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">居中</span>
				</div>
			</div>
		</div>
		<div style="padding: 10px;display: flex;">
			<div style="display: flex;align-items: center;" class="flex-item-center">
				<div style="font-size: 14px;width: 74px;">标题内容</div>
				<el-input size="small" style="margin-left: 6px;" v-model="dataItem.globalDialog.title"
					placeholder="请输入标题"></el-input>
			</div>
		</div>

		<div style="padding: 10px;display: flex;">
			<div style="display: flex;align-items: center;" class="flex-item-center">
				<div style="font-size: 14px;width: fit-content;">标题颜色</div>
				<el-color-picker style="margin-left: 10px;" v-model="dataItem.globalDialog.color"></el-color-picker>
			</div>
			<div style="display: flex;align-items: center;font-size: 14px;">
				<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
					<div>字体大小</div>
					<input @input="iptTit(dataItem.globalDialog)" v-model="dataItem.globalDialog.fontSize"
						style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;margin-left: 10px;" />px
				</div>
				<el-select  @change="changeFamily;changeSelect()" size="mini" style="width: 100px;margin-top:10px"
					v-model="dataItem.globalDialog.fontFamily" placeholder="选择字体">
					<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
						:value="fontItem.name">
					</el-option>
				</el-select>
			</div>
		</div> -->

		<div style="display: flex;align-items: center;font-size: 14px;">

			<div style="" class="flex-item-center"
				style="align-items: center;margin: 6px;display: flex;margin-top: 10px;">
				<div style="font-size: 14px;">组件边框</div>
				<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
					<div @click="dataItem.globalDialog.border.type = ''"
						:style="{backgroundColor: dataItem.globalDialog.border.type == ''?'#8c62ff':'#fff',color: dataItem.globalDialog.border.type == ''?'#fff':'#000',border: dataItem.globalDialog.border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">无</span>
					</div>
					<div @click="dataItem.globalDialog.border.type = 'solid'"
						:style="{backgroundColor: dataItem.globalDialog.border.type == 'solid'?'#8c62ff':'#fff',color: dataItem.globalDialog.border.type == 'solid'?'#fff':'#000',border: dataItem.globalDialog.border.type == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">实线</span>
					</div>
					<div @click="dataItem.globalDialog.border.type = 'dashed'"
						:style="{backgroundColor:dataItem.globalDialog.border.type == 'dashed'?'#8c62ff':'#fff',color:dataItem.globalDialog.border.type == 'dashed'?'#fff':'#000',border:dataItem.globalDialog.border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">虚线</span>
					</div>
				</div>
			</div>
			<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
				<div>边框颜色</div>
				<el-color-picker style="margin-left: 10px;"
					v-model="dataItem.globalDialog.border.color"></el-color-picker>
			</div>
		</div>


		<div style="display: flex;align-items: center;">
			<div style="display: flex;align-items: center;">
				<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
					<div>线条大小</div>
					<div
						style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeContainerSize" v-model="dataItem.globalDialog.border.borderSize[0]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">顶部</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeContainerSize" v-model="dataItem.globalDialog.border.borderSize[1]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">左侧</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeContainerSize" v-model="dataItem.globalDialog.border.borderSize[2]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">底部</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeContainerSize" v-model="dataItem.globalDialog.border.borderSize[3]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">右侧</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
							<i @click="borderContainerSizeAll = !borderContainerSizeAll"
								:style="{color:borderContainerSizeAll?'#8c62ff':'#000'}"
								style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
								class="el-icon-paperclip tit-icon"></i>
						</div>
					</div>
				</div>
			</div>

			<div style="display: flex;align-items: center;">
				<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
					<div>边框圆角</div>
					<div
						style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeContainerBorderRadius"
								v-model="dataItem.globalDialog.border.borderRadius[0]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">左上</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeContainerBorderRadius"
								v-model="dataItem.globalDialog.border.borderRadius[1]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">右上</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeContainerBorderRadius"
								v-model="dataItem.globalDialog.border.borderRadius[2]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">右下</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;">
							<input @input="changeContainerBorderRadius"
								v-model="dataItem.globalDialog.border.borderRadius[3]"
								style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
							<div style="margin-top: 2px;">左下</div>
						</div>
						<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
							<i @click="borderContainerRadiusAll = !borderContainerRadiusAll"
								:style="{color:borderContainerRadiusAll?'#8c62ff':'#000'}"
								style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
								class="el-icon-paperclip tit-icon"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
			<div>内边距</div>
			<div
				style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;margin-left: 20px;">
				<div style="display: flex;flex-direction: column;align-items: center;">
					<input @input="paddingSet" v-model="dataItem.globalDialog.padding[0]"
						style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
					<div style="margin-top: 2px;">顶部</div>
				</div>
				<div style="display: flex;flex-direction: column;align-items: center;">
					<input @input="paddingSet" v-model="dataItem.globalDialog.padding[2]"
						style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
					<div style="margin-top: 2px;">左侧</div>
				</div>
				<div style="display: flex;flex-direction: column;align-items: center;">
					<input @input="paddingSet" v-model="dataItem.globalDialog.padding[1]"
						style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
					<div style="margin-top: 2px;">底部</div>
				</div>
				<div style="display: flex;flex-direction: column;align-items: center;">
					<input @input="paddingSet" v-model="dataItem.globalDialog.padding[3]"
						style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
					<div style="margin-top: 2px;">右侧</div>
				</div>
				<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
					<i @click="paddingAll = !paddingAll" :style="{color:paddingAll?'#8c62ff':'#000'}"
						style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
						class="el-icon-paperclip tit-icon"></i>
				</div>
			</div>
		</div>
		<div style="display: flex;align-items: center;">
			<div style="margin-left: 10px;display: flex;align-items: center;font-size: 14px;">
				<div>弹窗背景设置</div>
				<div style="display: flex;align-items: center;margin-left: 10px;">
					<div @click="dataItem.globalDialog.bg.bgType = ''"
						:style="{backgroundColor:dataItem.globalDialog.bg.bgType == ''?'#8c62ff':'#fff',color:dataItem.globalDialog.bg.bgType == ''?'#fff':'#000',border:dataItem.globalDialog.bg.bgType == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
						<span style="scale: 0.85;">无</span>
					</div>
					<div @click="dataItem.globalDialog.bg.bgType = 'color'"
						:style="{backgroundColor:dataItem.globalDialog.bg.bgType == 'color'?'#8c62ff':'#fff',color:dataItem.globalDialog.bg.bgType == 'color'?'#fff':'#000',border:dataItem.globalDialog.bg.bgType == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
						<span style="scale: 0.85;">纯色背景</span>
					</div>
					<div @click="dataItem.globalDialog.bg.bgType = 'gradient'"
						:style="{backgroundColor:dataItem.globalDialog.bg.bgType == 'gradient'?'#8c62ff':'#fff',color:dataItem.globalDialog.bg.bgType == 'gradient'?'#fff':'#000',border:dataItem.globalDialog.bg.bgType == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
						<span style="scale: 0.85;">渐变背景</span>
					</div>
					<div @click="dataItem.globalDialog.bg.bgType = 'img'"
						:style="{backgroundColor:dataItem.globalDialog.bg.bgType == 'img'?'#8c62ff':'#fff',color:dataItem.globalDialog.bg.bgType == 'img'?'#fff':'#000',border:dataItem.globalDialog.bg.bgType == 'img'?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="border: solid 1px #959595;padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
						<span style="scale: 0.85;">图片背景</span>
					</div>
				</div>
			</div>
			<div v-if="dataItem.globalDialog.bg.bgType == 'color'"
				style="display: flex;align-items: center;font-size: 14px;margin-left: 10px;">
				<div>背景纯色设置</div>
				<el-color-picker size="small" style="margin-left: 10px;" v-model="dataItem.globalDialog.bg.bgColor"></el-color-picker>
			</div>
			
			<div v-if="dataItem.globalDialog.bg.bgType == 'gradient'"
				style="display: flex;align-items: center;font-size: 14px;margin-left: 10px;">
				<div>背景渐变设置</div>
				<div style="margin-left: 10px;">
					<div style="display: flex;flex-direction: column;">
						<el-input size="small" style="width: 260px;margin-top: 4px;" type="textarea" :rows="1" placeholder="请输入内容"
							v-model="dataItem.globalDialog.bg.bgGradient">
						</el-input>
					</div>
					<div style="margin-top: 6px;font-size: 12px;color: #55aaff;transform: scale(0.85);">
						需要自定义模板设置请访问 <a target="_blank" style="margin-left: 4px;"  href="https://www.eggradients.com/gradient-maker">gradient-maker</a> 
					</div>
				</div>
			</div>
			
			
			<div v-if="dataItem.globalDialog.bg.bgType == 'img'"
				style="padding: 10px;display: flex;align-items: center;font-size: 14px;">
				<div>背景图片设置</div>
				<div style="display: flex;align-items: center;margin-left: 10px;cursor: pointer;">
					<div v-if="dataItem.globalDialog.bg.bgImg.url == ''" @click="dialogVisibleImgs = true"
						style="width: 60px;height: 60px;border: solid 1px #cacaca ;border-radius: 6px;display: flex;align-items: center;justify-content: center;">
						<i style="font-size: 20px;" class="el-icon-plus"></i>
					</div>
					<div v-if="dataItem.globalDialog.bg.bgImg.url != ''"
						style="border: solid 1px #cacaca ;border-radius: 6px;position: relative;width: 60px;height: 60px;">
						<img @mouseleave="mask = false" @mouseenter="mask = true"
							style="width: 60px;height: 60px;position: absolute;z-index: 1;border-radius: 6px;"
							@click="dialogVisibleImgs = true" :src="dataItem.globalDialog.bg.bgImg.url" />
						<div @mouseleave="mask = false" @mouseenter="mask = true" v-show="mask"
							style="width: 60px;height: 60px;background-color: #000;opacity: 0.6;position: absolute;z-index: 10;border-radius: 6px; display: flex;align-items: center;justify-content: center;font-size: 20px;">
			
						</div>
						<div @mouseleave="mask = false" @mouseenter="mask = true" v-show="mask"
							style="color: #fff;width: 60px;height: 60px;position: absolute;z-index: 100;border-radius: 6px;display: flex;align-items: center;justify-content: center;font-size: 20px;">
							<i @click="dialogVisibleImgs = true" class="el-icon-picture"></i>
							<i @click="dataItem.globalDialog.bg.bgImg.url = ''" style="margin-left: 20px;"
								class="el-icon-delete"></i>
						</div>
					</div>
				</div>
				<div>
					<div style="display: flex;align-items: center;margin-left: 10px;">
						<div>
							背景重复
						</div>
						<el-select size="mini"  @change="changeSelect" style="margin-left: 10px;width: 120px;"
							v-model="dataItem.globalDialog.bg.bgImg.type" filterable allow-create default-first-option
							placeholder="渲染方式">
							<el-option label="x轴重复" value="repeat-x">
							</el-option>
							<el-option label="y轴重复" value="repeat-y">
							</el-option>
							<el-option label="平铺" value="">
							</el-option>
							<el-option label="不平铺" value="no-repeat">
							</el-option>
						</el-select>
					</div>
					<div style="display: flex;align-items: center;margin-left: 10px;margin-top: 10px;">
						<div>
							背景位置
						</div>
						<el-select size="mini" @change="changeSelect" style="margin-left: 10px;width: 120px;"
							v-model="dataItem.globalDialog.bg.bgImg.position" filterable allow-create default-first-option
							placeholder="图片位置">
							<el-option label="左上方" value="top left">
							</el-option>
							<el-option label="上中间" value="top center">
							</el-option>
							<el-option label="右上方" value="top right">
							</el-option>
							<el-option label="左中方" value="center left">
							</el-option>
							<el-option label="居中" value="center center">
							</el-option>
							<el-option label="右中方" value="center right">
							</el-option>
							<el-option label="下左方" value="bottom left">
							</el-option>
							<el-option label="下居中" value="bottom center">
							</el-option>
							<el-option label="下右方" value="bottom right">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex-direction: column;margin-left: 4px;">
					<el-input size="mini"  @input="changeSelect" onkeyup="this.value=this.value.replace(/\D/g,'')" style="width: 160px;"
						v-model="dataItem.globalDialog.bg.bgImg.width" placeholder="自定义宽度">
						<template slot="append">px</template>
					</el-input>
					<el-input size="mini"  @input="changeSelect" onkeyup="this.value=this.value.replace(/\D/g,'')"
						style="width: 160px;margin-top: 10px;" v-model="dataItem.globalDialog.bg.bgImg.height"
						placeholder="自定义高度">
						<template slot="append">px</template>
					</el-input>
				</div>
				<el-dialog custom-class="select-imgs" title="文件管理器" :visible.sync="dialogVisibleImgs" width="80%"
					:before-close="()=>{dialogVisibleImgs = false}">
					<select-img style="height: 70vh"
						@confirmImg="confirmSelectImg($event,'dialogVisibleImgs',dataItem.globalDialog.bg.bgImg)"
						v-if="dialogVisibleImgs"></select-img>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	import selectImg from '../components/selectImg.vue'
	export default {
		components: {
			selectImg
		},
		props: {
			dataItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			fontList: {
				type: Array,
				default: () => {
					return []
				}
			},
			fontFamilyName: {
				type: String,
				default: ''
			},
		},
		data() {
			return {
				mask: false,
				dialogVisibleImgs: false,
				borderContainerRadiusAll: true,
				paddingAll: true,
				marginAll: true,
				borderContainerSizeAll: true
			}
		},
		mounted() {
			if(this.fontFamilyName && !this.dataItem.globalDialog.fontFamily){
				this.dataItem.globalDialog.fontFamily = this.fontFamilyName
			}
			
			if(!this.dataItem.globalDialog.onlyHomeShow){
				this.$set(this.dataItem.globalDialog,'onlyHomeShow','true')
			}
			
			if(!this.dataItem.globalDialog.closeNoShow){
				this.$set(this.dataItem.globalDialog,'closeNoShow','true')
			}
		},
		methods: {
			changeFamily(e) {
				console.log('this.fontList', e)
				console.log('this.fontList', this.fontList)
				console.log('changeFamilye', e)
				// this.fontList.forEach(item=>{
				// 	if(item.name == e){
				// 		this.dataItem.globalDialog.fontCss = item.css
				// 		this.dataItem.globalDialog.fontName = item.code
				// 		console.log('globalDialog',this.dataItem.globalDialog)
				// 	}
				// })
			},
			confirmSelectImg(e, type, dataItem) {
				dataItem.url = e.url
				this.dialogVisibleImgs = false
				this.mask = false
				console.log('e', e)
			},
			changeSelect() {
				this.mask = !this.mask
				this.$nextTick(() => {
					this.mask = !this.mask
				})
				console.log('mask', this.mask)
			},
			iptTit(e) {
				e.fontSize = e.fontSize.replace(/\D/g, '')
			},
			paddingSet(e) {
				console.log('event.target.value', event.target.value)
				if (this.paddingAll) {
					this.dataItem.globalDialog.padding = []
					this.dataItem.globalDialog.padding.push(e.target.value)
					this.dataItem.globalDialog.padding.push(e.target.value)
					this.dataItem.globalDialog.padding.push(e.target.value)
					this.dataItem.globalDialog.padding.push(e.target.value)
				}
			},
			changeContainerSize(e) {
				if (this.borderContainerSizeAll) {
					this.dataItem.globalDialog.border.borderSize = []
					this.dataItem.globalDialog.border.borderSize.push(e.target.value)
					this.dataItem.globalDialog.border.borderSize.push(e.target.value)
					this.dataItem.globalDialog.border.borderSize.push(e.target.value)
					this.dataItem.globalDialog.border.borderSize.push(e.target.value)
				}
			},
			changeContainerBorderRadius(e) {
				if (this.borderContainerRadiusAll) {
					this.dataItem.globalDialog.border.borderRadius = []
					this.dataItem.globalDialog.border.borderRadius.push(e.target.value)
					this.dataItem.globalDialog.border.borderRadius.push(e.target.value)
					this.dataItem.globalDialog.border.borderRadius.push(e.target.value)
					this.dataItem.globalDialog.border.borderRadius.push(e.target.value)
				}
			},
		}
	}
</script>

<style scoped>
	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}

	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;
	}
</style>